
const isDefaultExpanded = (pathName, expansionSettings) => {

    if(pathName != "/") 
        return false
    
    if(!expansionSettings?.defaultExpandedFrom || !expansionSettings?.defaultExpandedTo)
        return false

    const defaultExpandedFromTicks = Date.parse(expansionSettings.defaultExpandedFrom);
    let defaultExpandedToTicks = Date.parse(expansionSettings.defaultExpandedTo);

    if(isNaN(defaultExpandedFromTicks) || isNaN(defaultExpandedToTicks)){
        console.error("isDefaultExpanded, Invalid date-format")
        return false
    }

    defaultExpandedToTicks += 86399999 // 1day-1ms in ms

    const defaultExpandedFromDate = new Date(defaultExpandedFromTicks)
    const defaultExpandedToDate = new Date(defaultExpandedToTicks)

    if(new Date() > defaultExpandedFromDate && new Date() < defaultExpandedToDate)
        return true

    return false;

}



export default isDefaultExpanded